<div class="alert-success" *ngIf="successMessageAlert">
    <img style="margin-right: 1em;" src="../assets/images/checkCircle.svg" alt="successMsg">
    <span class="alert-close" (keyup)="closealert()" (click)="closealert()">&times;</span>
    <span>{{successMssg}}</span>

</div>
<div class="alert-failure" *ngIf="failureMessageAlert">
    <img style="margin-right: 1em;" src="../assets/images/errCircle.png" alt="failureMsg">
    <span class="alert-close" (keyup)="closealert()" (click)="closealert()">&times;</span>
    <span>{{failureMsg}}</span>

</div>
<div *ngIf="displayScreen">
    <div class="container-fluid">
        <div class="ms-3">
            <form [formGroup]="emailForm">
            <div class="mt-3" style="padding-bottom: 190px; padding-right: 10px;">
                <div class="d-flex flex-row">
                    <div class="col-7 col-md-7 me-1">
                        <ag-grid-angular  class="ag-theme-balham me-4" [rowData]="rowDataForEmailer"  [columnDefs]="columnDefForEmailer" [pagination]="true" [paginationPageSize]="10"
                            headerHeight="50" [defaultColDef]="defaultColDef" [domLayout]="domLayout"
                            [floatingFiltersHeight]="50" style="margin-right: 0px !important;" [enableCellTextSelection] = "true"
                            [rowSelection]="rowSelection" (selectionChanged)="onSelection()" [icons]="icons"
                            (gridReady)="onGridReady($event)" [excelStyles]="excelStyles" [tooltipShowDelay]="tooltipShowDelay">
                        </ag-grid-angular>
                    </div>
                    <div class="col-5 col-md- ms-1">
                        <span class="emailListPreviewHeader"> EMAIL LIST PREVIEW DISPLAY </span>
                        <div class="cardBody mt-2 pb-2 pt-1">
                            <div class="reportDetails">
                                <div class="d-flex m-2 pb-2">
                                    <div class="col-md-2"><label for="subject" class="label-tmna ms-2 required">Subject:</label></div>
                                        <div class="col-md-10 ms-2">
                                        <input class="input-tmna" formControlName="subject" type="text" style="width: 75%" placeholder="Enter Subject" (input)="validateSubject($event)" min="2" max="100">
                                        <div *ngIf="subjectField || errorSubject" class="label-tmna ms-2">
                                            <span style="color: red;">*Please enter a valid subject (must start with a letter, minimum 2 and maximum 100 characters. Can contain only letters, numbers, and spaces).</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex m-2 pb-2">
                                    <div class="col-md-2"><label for="emailBody" class="label-tmna ms-2 required" >Email Body:</label></div>
                                    <div class="col-md-10 ms-2"> 
                                        <quill-editor #editor class="quillEditorField" [modules]="{toolbar: ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', {'header': []}, {'align': []}, {'color': []}, {'background': []}, 'link', {'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}]}" 
                                        [styles]="{height: '100px'}" formControlName="emailBody"></quill-editor><br>
                                        <div *ngIf="bodyField" style="color:red;font-size:12px;"> Required </div>
                                        <div class="attachmentTooltip mt-1">
                                            Add an Attachment with the Browser… and add it by clicking “Save Content”. You can remove an Attachment by checking an Attachment and clicking “Remove Att”.<b> You are limited to an individual file size of 5MB and total combined file size of 10MB.</b>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex m-2 pb-2">
                                    <div class="col-md-2">
                                        <label for="attachment" class="label-tmna ms-2">Attachment:</label>
                                    </div>
                                    <div class="col-md-10 ms-2">
                                        <div class="d-flex attachingFiles">
                                            <div class="d-flex file-item" style="padding-bottom: 10px; gap: 10px;" *ngFor = "let file of files; let i = index">
                                                <input type="checkbox" class="shadow-none" [(ngModel)]="file.isSelected" [ngModelOptions]="{standalone: true}" (change)="onCheckboxSelected()"/>
                                                <div class="attachmentSection">
                                                    <label for="attachedFileName" class="label-tmna">{{file.name}}</label>
                                                    <button type="button" class="btn-close" (click)="removeAttachment(i)" (keyup)="removeAttachment(i)">
                                                        <img src="\assets\images\close-icon.png" height="15" width="15" alt="Remove Attachment">
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex" style="gap: 10px;">
                                            <button class="closeButton" (click)="fileInput.click()" style="width: fit-content;">ATTACH FILE</button>
                                            <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;"/>
            
                                            <span class="label-tmna pt-2 noFilesChosen" *ngIf="!isAnyFilesChosen">No Files Chosen</span>
            
                                            <button class="closeButton" style="width: fit-content;" (click)="saveEmail()">SAVE EMAIL CONTENT</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="filesizeerr" class="fileUploadErrorMsg"> Please limit total file size upto 10MB </div>
                            <div *ngIf="fileTypeErr" class="fileUploadErrorMsg"> Please upload only files with extension .pdf or .xls or .xlsx </div>
                            <div class="m-2 pb-2">
                                <div class="ms-2 recipientsToolTipContent">
                                    <span class="label-tmna">
                                        Test email recipients. ** Please use comma(,) to separate emails.
                                    </span>
                                    <textarea class="label-tmna-big" formControlName="testAddress" placeholder="Test email recipients content" style="width: 95%;" rows="2"></textarea>
                                    <div *ngIf="recerr" style="color:red;font-size:12px;"> Please enter valid email ids for test</div>
                                </div>
                            </div> 
                            
                    <div class="d-flex  m-2 pb-2" >
                        <div class="col-md-2"><label for="sendType" class="label-tmna ms-2" >Send Type:</label></div>
                        <div class="col-md-10"> 
                        <input type="checkbox" class="shadow-none mb-1" formControlName="test" >&nbsp;<span class="label-tmna mr">Test</span>
                        
                            <input type="checkbox" class="shadow-none mb-1" formControlName="escalateMgr" >&nbsp;<span class="label-tmna mr">Escalate to Manager</span>
                        <label for="send" class="label-tmna me-2 mr">
                            <input type="radio" name="emailRadio" formControlName="emailRadio" value="send" class="shadow-none"> Send
                        </label>
                        <label for="resend" class="label-tmna me-2 mr" >
                            <input type="radio" name="emailRadio" formControlName="emailRadio" value="resend" class="shadow-none"> Resend
                        </label>
                        </div>
                    </div> 
                        </div>
                    </div>
                </div>
            </div>
            <nav class="navbar navbar-expand-lg footer-tab fixed-bottom mt-2" aria-label="send email">
                
            
                <div class="ms-3">
                    <button (click)="exportGrid()" class="closeButton ms-2 me-4 mb-20" style="width: fit-content;margin-bottom: 20px"
                        [ngClass]="{'disableBtn': disableExportEmailer}">
                        EXPORT GRID
                    </button>
                    </div>
                    <div style="flex:auto">
                    <button (click)="sendcheck()" class="closeButton ms-2 me-4 mb-20" style="width: fit-content;margin-bottom: 20px"
                        [ngClass]="{'noSupplierSelected': !isSupplierSelected}">
                        SEND EMAIL
                    </button>
                    </div>
            
            </nav>
            </form>
        </div>
    </div>
</div>

    <div class="modal" tabindex="-1" *ngIf="showModel" [ngStyle]="{'display': showModel ? 'block':'none'}">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <button type="button" class="close" data-bs-dismiss="modal" (click)="closeEmailerModel()"> 
                    <img src="\assets\images\close-icon.png" alt="Close Modal" height="15" width="15" >
                </button>
          
                <div class="modal-header" id="addModalHeader"
                    style=" display: flex; justify-content: space-between;align-items:end  ">
                    
                    <h4 class="modal-title inl-modal-padding modalHeading">
                        <span *ngIf="showTestModelContent">Send Test Email</span>
                        <span *ngIf="!showTestModelContent">Send Email</span>
                    </h4>
        
                </div>
                <div class="modal-body">
                    <span class="label-tmna" *ngIf="showTestModelContent">Are you sure you want to send test email?</span>
                    <span class="label-tmna" *ngIf="!showTestModelContent">Are you sure you want to send the emails to the Suppliers?</span>
                </div>
                <div class="modal-footer">
                    <button class="closeButton me-2" (click)="closeEmailerModel()"> NO </button>
                    <button class="addButton" (click)="sendEmail(); closeEmailerModel();"> YES </button>
                </div>
            </div>
        </div>
    </div>

<div *ngIf="displayUnauthorized">
    <div class=" container unauthorized" *ngIf="displayUnauthorized" >
        <p></p>
        <p style="color: red;">You do not have a role assigned to access this Application.</p>
        <p>Please raise a request using 
        <a style="color: #2688Da; text-decoration:underline" href="https://ep.idm.toyota.com/identityiq/home.jsf" >SailPoint</a>.
        Refer to the <span style="color: #2688Da; text-decoration:underline; cursor:pointer">User Guide</span>
        for more details.
        </p>
        <p style="color: #2688Da; text-decoration:underline; cursor: pointer;" 
            (click)="cancelNullGuidAssume()" 
            (keydown)="cancelNullGuidAssume()" 
            *ngIf="cancelAssumedUser" >Cancel Assume</p>
    </div>
</div>